import { render } from "./subRetailerDetail.vue?vue&type=template&id=3021b302&scoped=true"
import script from "./subRetailerDetail.vue?vue&type=script&lang=js"
export * from "./subRetailerDetail.vue?vue&type=script&lang=js"

import "./subRetailerDetail.vue?vue&type=style&index=0&id=3021b302&scoped=true&lang=css"

import exportComponent from "C:\\WSS-BuildAgent\\_work\\5\\s\\Sureload Admin\\sureload-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3021b302"]])

export default __exports__